import React, { useRef, useState } from 'react';
// import { faro } from "@grafana/faro-web-sdk";
import ClearIcon from '@material-ui/icons/Clear';

// import { useFileUploadGetQuery } from "../../Common/Queries/applicationsQueries"; // need to change this
import { getBaseUrl, FILE_UPLOAD } from '../../../constant';
// import { validateCustomFields } from "../../utils";
import { TextField, Button, CircularProgress, Grid, IconButton } from '@material-ui/core';
import { ACCEPT_TYPES } from '../../../constant';

import { PrimaryCustomButton } from '../CustomButton';
import { AlertErrorComponent } from '../Error/Error';

import './index.css';
import { validateCustomFields } from '../../../utils';

async function fileUpload() {
  const url = `${getBaseUrl()}${FILE_UPLOAD}`;
  try {
    const response = await fetch(url);
    if (!response.ok) throw new Error('Network error');

    const data = await response.json();
    return data;
  } catch (error) {
    return error;
  }
  // .then((response) => {
  //   if (response.ok) {
  //     return response.json();
  //   }
  //   return Promise.reject(response);
  // })
  // .then((data) => {
  //   const uploadURL = data.data["upload-url"];
  //   const file = new Blob([resumeValue], {
  //     type: resumeValue.type,
  //   });
  //   fetch(uploadURL, {
  //     method: "PUT",
  //     body: file,
  //   }).then((response) => {
  //     if (response.ok) {
  //       setLoading((prevLoading) => {
  //         return { ...prevLoading, resumeLoading: false };
  //       });
  //       dispatch({
  //         type: ACTIONS.RESUME,
  //         payload: {
  //           value: data?.data?.url,
  //           name: resumeValue.name,
  //         },
  //       });
  //     }
  //   });
  // })
  // .catch((error) => {
  //   setLoading((prevLoading) => {
  //     return { ...prevLoading, resumeLoading: false };
  //   });
  //   setError((prevValues) => {
  //     return {
  //       ...prevValues,
  //       status: true,
  //       message: <Message dictKey="err.upload.again" />,
  //     };
  //   });
  // });
}

export function FileUpload({
  handleOnFileUploading = () => {},
  handleOnSuccess,
  handleOnUploadError = () => {},
  buttonText = 'Upload File',
  uploadLocation,
  setError = () => {},
  fileValidationDetails = () => {},
  disabled = false,
  setCustomFieldsValidation,
}) {
  const hiddenFileInput = useRef();

  const [fileName, setFileName] = useState('');
  const [fileStatus, setFileStatus] = useState('');
  const [message, setMessage] = useState('');

  // const { refetch } = useFileUploadGetQuery();

  const handleFileUpload = async (event) => {
    event.preventDefault();
    // ? custom fields file validation
    if (uploadLocation === 'custom-file-upload') {
      const fieldData = {
        ...fileValidationDetails,
        fileType: event.target.files[0].type,
        fileSize: event.target.files[0].size,
      };
      const resp = validateCustomFields(fieldData);
      if (!resp.isValid) {
        setError(resp.errorMessage);
        setCustomFieldsValidation((prev) => ({
          ...prev,
          [fileValidationDetails?.fieldName]: false,
        }));
        return;
      }
      setError('');
      setCustomFieldsValidation((prev) => ({
        ...prev,
        [fileValidationDetails?.fieldName]: true,
      }));

      if (!fieldData.value) setError('');
    }

    let resumeValue = event.target.files && event.target.files[0];
    if (!resumeValue) resumeValue = event?.dataTransfer?.files && event?.dataTransfer?.files[0];
    if (resumeValue) {
      const fileSize = resumeValue.size / 1024 / 1024;
      if (fileSize > 5) {
        setFileStatus('ERROR');
        setMessage('file size should not be more than 5MB');
        return;
      }
      if (
        resumeValue.type !== 'image/jpeg' &&
        resumeValue.type !== 'image/webp' &&
        resumeValue.type !== 'image/png' &&
        resumeValue.type !== 'application/pdf' &&
        resumeValue.type !== 'application/msword' &&
        resumeValue.type !==
          'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
      ) {
        setFileStatus('ERROR');
        setMessage('file should be of type .pdf, .doc, .docx, .png, .webp, .jpeg only');
        return;
      }
      try {
        setFileStatus('LOADING');
        const { data } = await fileUpload();
        const uploadUrl = data?.['upload-url'];
        if (!uploadUrl) {
          throw new Error('Failed to get upload URL');
        }
        handleOnFileUploading(true);
        const file = new Blob([resumeValue], {
          type: resumeValue.type,
        });
        const resp = await fetch(uploadUrl, {
          method: 'PUT',
          body: file,
        });
        if (!resp.ok) {
          throw resp;
        }
        setFileStatus('UPLOADED');
        setFileName(resumeValue.name);
        handleOnSuccess({
          data: { value: data?.url },
        });
      } catch (error) {
        // if (faro && faro.api && faro.api.pushError) {
        //   faro.api.pushError(error);
        // }
        setFileStatus('ERROR');
        setMessage('error while uploading the file');
        handleOnUploadError({
          error: { message: 'file upload fails', status: error.status },
        });
      }
    }
  };

  const handleOnFileClear = (e) => {
    e.preventDefault();
    setFileName('');
    handleOnSuccess({ data: { value: '' } });
  };

  return (
    <div className="application-same-row-wrapper-item">
      {fileStatus === 'ERROR' && (
        <AlertErrorComponent
          message={message}
          handleClose={(_value) => {
            setFileStatus('');
            setMessage('');
          }}
        />
      )}
      <TextField
        inputRef={hiddenFileInput}
        fullWidth
        style={{ display: 'none', marginTop: '5px' }}
        id="resume"
        type="file"
        inputProps={{
          'data-testid': 'testResume',
          accept: ACCEPT_TYPES,
        }}
        InputLabelProps={{
          shrink: true,
        }}
        onChange={handleFileUpload}
        key={Date.now()}
      />
      <PrimaryCustomButton
        data-testid="testResumeButton"
        id="add-resume-button"
        style={{ whiteSpace: 'nowrap', padding: '10px 20px' }}
        disabled={fileName !== '' || fileStatus === 'LOADING' || disabled}
        onClick={() => {
          hiddenFileInput.current.click();
        }}
        onDragOver={(e) => {
          e.preventDefault();
        }}
        onDragEnter={(e) => {
          e.preventDefault();
        }}
        onDragLeave={(e) => {
          e.preventDefault();
        }}
        onDrop={handleFileUpload}
      >
        {buttonText}
      </PrimaryCustomButton>
      {fileStatus === 'LOADING' && (
        <CircularProgress className="resume-name" color="inherit" size={30} />
      )}
      <span className="resume-name">{fileName}</span>
      {fileName && (
        <IconButton onClick={handleOnFileClear} data-testid="testClearResume">
          <ClearIcon />
        </IconButton>
      )}
    </div>
  );
}
